
// @ts-check

import { cloneDeep, find } from 'lodash';

export const columnSettings = {
  name: {
    name: 'name',
    sort: 'asc',
    defaultSort: 'asc',
    displayName: 'WEBHOOKS_NAME'
  },
  callId: {
    name: 'callId',
    sort: 'asc',
    displayName: 'WEBHOOKS_CALL_ID'
  },
  revenue: {
    name: 'revenue',
    sort: 'asc',
    displayName: 'WEBHOOKS_REVENUE'
  },
  parameterTest: {
    name: 'parameterTest',
    sort: 'asc',
    displayName: 'WEBHOOKS_FIRE_PIXEL'
  }
};

export const defaultColumns = [
  'name',
  'callId',
  'revenue',
  'parameterTest'
];

export function _parseWebHook(webHook) {
  const {
    id,
    qPathMaps,
    parameterTest,
    name
  } = webHook || {};

  const [
    incomingCallIdQueryStringParameter,
    conversionAmountQueryStringParameter
  ] = (qPathMaps || []).map(path => path.incomingQueryStringName);
  
  return {
    id,
    incomingCallIdQueryStringParameter,
    conversionAmountQueryStringParameter,
    conversionCriteriaParameterMatch: parameterTest,
    name: name
  };
}


export default class WebhookService {

  /**
   * @ngInject
   * @param {import('lodash').LoDashStatic} _ 
   * @param {import('angular').IHttpService} $http 
   * @param {*} authService 
   * @param {*} ngAuthSettings 
   */
  constructor(_, $http, authService, ngAuthSettings) {

    this.$http = $http;
    this.authService = authService;
    this.ngAuthSettings = ngAuthSettings;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
    this.columnSettings = cloneDeep(columnSettings);
    this.defaultColumns = [...defaultColumns];
  }

  getWebHooks(accountId) {
    const url = this.serviceBaseUri + accountId + '/webhooks';

    return this.$http.get(url);
  }

  getWebHook(accountId, webhookId) {
    const url = this._serviceBaseUrl(accountId, webhookId);
    return this.$http.get(url);
  }

  createWebHook(accountId, webhook) {
    const url = this.serviceBaseUri + accountId + '/webhooks/createConversion';
    return this.$http.post(url, webhook);
  }

  createWebHookConversion(accountId, webHook) {
    const url = this.serviceBaseUri + accountId + '/webhooks/createConversion';
    return this.$http.post(url, webHook);
  }

  deleteWebHook(accountId, webHookId) {
    const url = this._serviceBaseUrl(accountId, webHookId);
    return this.$http.delete(url);
  }

  updateWebHook(accountId, webHook) {
    const url = this._serviceBaseUrl(accountId, webHook.id);
    return this.$http.put(url, webHook);
  }

  hasCampaign(webHook) {
    if (webHook.defaultValues.length > 0) {
      find(webHook.defaultValues, { 'key': 'campaignId' });
      return true;
    } else {
      return false;
    }
  }

  _serviceBaseUrl(accountId, webhookId) {
    return this.serviceBaseUri + accountId + '/webhooks/' + webhookId;
  }

}